import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useBranches } from '@/hooks/api/branches';

interface BranchFilterProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/** Filial bo'yicha filtr — barcha ro'yxatlarda bir xil ko'rinish */
export function BranchFilter({ value, onChange, className }: BranchFilterProps) {
  const { t } = useTranslation();
  const { data: branches = [] } = useBranches();

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className ?? 'w-[180px]'}>
        <Building2 size={14} className="text-muted-foreground mr-1" />
        <SelectValue placeholder={t('misc_geo.all_branches')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t('misc_geo.all_branches')}</SelectItem>
        {branches.map((b: any) => (
          <SelectItem key={b.id} value={String(b.id)}>{b.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default BranchFilter;
